import React from "react";
import "../../styles/common/dashboardOverviewSection.scss";
import TooltipText from "./tooltipText";
import SchoolOutlinedIcon from "@mui/icons-material/SchoolOutlined";
import MenuBookOutlinedIcon from "@mui/icons-material/MenuBookOutlined";
import GroupWorkOutlinedIcon from "@mui/icons-material/GroupWorkOutlined";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";

const DashboardOverviewSection = ({
  overall,
  showTotalInstitutions = true,
}) => {
  const safeOverall = overall || {};

  const formatSeconds = (seconds) => {
    const raw = Number(seconds);
    if (!Number.isFinite(raw) || raw <= 0) return "0";

    const totalSeconds = Math.floor(raw);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);

    if (hours > 0) return `${hours}h ${minutes}m`;
    return `${minutes}m`;
  };

  const hasTimeSpent =
    safeOverall.avg_time_spent_per_user_seconds != null ||
    safeOverall.total_time_spent_seconds != null;
  const showTeachers = safeOverall.total_teachers != null;

  return (
    <section className="dashboard-overview-section">
      {/* <h2>Overview</h2> */}
      <div className="overview-grid">
        {showTotalInstitutions && (
          <div className="card overview-card">
            <div className="overview-card-content">
              <div className="overview-card-text">
                <TooltipText
                  text="Total Institutions"
                  className="overview-card-label"
                  fullWidth
                />
                <strong>{safeOverall.total_institutions ?? 0}</strong>
              </div>
              <SchoolOutlinedIcon
                className="overview-card-icon"
                sx={{ color: "#FCA43B !important" }}
              />
            </div>
          </div>
        )}
        <div className="card overview-card">
          <div className="overview-card-content">
            <div className="overview-card-text">
              <TooltipText
                text="Total Courses"
                className="overview-card-label"
                fullWidth
              />
              <strong>{safeOverall.total_courses ?? 0}</strong>
            </div>
            <MenuBookOutlinedIcon className="overview-card-icon" />
          </div>
        </div>
        <div className="card overview-card">
          <div className="overview-card-content">
            <div className="overview-card-text">
              <TooltipText
                text="Total Batches"
                className="overview-card-label"
                fullWidth
              />
              <strong>{safeOverall.total_batches ?? 0}</strong>
            </div>
            <GroupWorkOutlinedIcon className="overview-card-icon" />
          </div>
        </div>
        <div className="card overview-card">
          <div className="overview-card-content">
            <div className="overview-card-text">
              <TooltipText
                text="Total Students"
                className="overview-card-label"
                fullWidth
              />
              <strong>{safeOverall.total_students ?? 0}</strong>
            </div>
            <GroupsOutlinedIcon className="overview-card-icon" />
          </div>
        </div>
        {hasTimeSpent && (
          <div className="card overview-card time-spent-overview-card">
            <div className="overview-card-content">
              <div className="overview-card-text">
                <TooltipText
                  text="Time Spent"
                  className="overview-card-label main-label"
                  fullWidth
                />
                <div className="time-stats-rows">
                  <div className="time-stat-row">
                    <span className="overview-card-label">Avg / User</span>
                    <strong className="time-value">
                      {formatSeconds(
                        safeOverall.avg_time_spent_per_user_seconds,
                      )}
                    </strong>
                  </div>
                  <div className="time-stat-row">
                    <span className="overview-card-label">Total</span>
                    <strong className="time-value">
                      {formatSeconds(safeOverall.total_time_spent_seconds)}
                    </strong>
                  </div>
                </div>
              </div>
              <AccessTimeOutlinedIcon className="overview-card-icon" />
            </div>
          </div>
        )}
        {showTeachers && (
          <div className="card overview-card">
            <div className="overview-card-content">
              <div className="overview-card-text">
                <TooltipText
                  text="Total Teachers"
                  className="overview-card-label"
                  fullWidth
                />
                <strong>{safeOverall.total_teachers ?? 0}</strong>
              </div>
              <PersonOutlineOutlinedIcon className="overview-card-icon" />
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default DashboardOverviewSection;
